/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AllocationRunOutput,
  CustomAssetLifecycle,
  HTTPValidationError,
  OptimizationMeta,
  OptimizationRequest,
  OptimizationResponse,
  OptimizationResult,
  OptimizerDetail,
} from '../models/index';
import {
    AllocationRunOutputFromJSON,
    AllocationRunOutputToJSON,
    CustomAssetLifecycleFromJSON,
    CustomAssetLifecycleToJSON,
    HTTPValidationErrorFromJSON,
    HTTPValidationErrorToJSON,
    OptimizationMetaFromJSON,
    OptimizationMetaToJSON,
    OptimizationRequestFromJSON,
    OptimizationRequestToJSON,
    OptimizationResponseFromJSON,
    OptimizationResponseToJSON,
    OptimizationResultFromJSON,
    OptimizationResultToJSON,
    OptimizerDetailFromJSON,
    OptimizerDetailToJSON,
} from '../models/index';

export interface GetAccountGroupOptimizerDetailsRequest {
    optimizationId: number;
    accountGroupGuid: string;
}

export interface GetCustomAssetLifecycleRequest {
    optimizationId: number;
    pId: string;
}

export interface GetOptimizationMetaRequest {
    fromDate?: string;
    toDate?: string;
}

export interface GetOptimizationResultRequest {
    optimizationId: number;
}

export interface GetOptimizerDetailsRequest {
    optimizationId: number;
    pId: string;
}

export interface GetSingleOptimizationMetaRequest {
    optimizationId: number;
}

export interface RunAllocationRequest {
    accountGroupGuid: string;
}

export interface SubmitOptimizationRequest {
    optimizationRequest: OptimizationRequest;
}

/**
 * 
 */
export class OptimizationApi extends runtime.BaseAPI {

    /**
     * Optimizer details of every account in the account group, for portfolio-level allocation debugging
     */
    async getAccountGroupOptimizerDetailsRaw(requestParameters: GetAccountGroupOptimizerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OptimizerDetail>>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling getAccountGroupOptimizerDetails.');
        }

        if (requestParameters.accountGroupGuid === null || requestParameters.accountGroupGuid === undefined) {
            throw new runtime.RequiredError('accountGroupGuid','Required parameter requestParameters.accountGroupGuid was null or undefined when calling getAccountGroupOptimizerDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/optimizer-details/account-group/{account_group_guid}`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))).replace(`{${"account_group_guid"}}`, encodeURIComponent(String(requestParameters.accountGroupGuid))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OptimizerDetailFromJSON));
    }

    /**
     * Optimizer details of every account in the account group, for portfolio-level allocation debugging
     */
    async getAccountGroupOptimizerDetails(requestParameters: GetAccountGroupOptimizerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OptimizerDetail>> {
        const response = await this.getAccountGroupOptimizerDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * 1. Collect inputs - meta (dates, algo action), detail frames from the custom asset algo, and asset info 2. Run and return the position-level Lifecycle report.
     * Get Custom Asset Lifecycle
     */
    async getCustomAssetLifecycleRaw(requestParameters: GetCustomAssetLifecycleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CustomAssetLifecycle>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling getCustomAssetLifecycle.');
        }

        if (requestParameters.pId === null || requestParameters.pId === undefined) {
            throw new runtime.RequiredError('pId','Required parameter requestParameters.pId was null or undefined when calling getCustomAssetLifecycle.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/custom-asset-lifecycle/p-id/{p_id}`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))).replace(`{${"p_id"}}`, encodeURIComponent(String(requestParameters.pId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CustomAssetLifecycleFromJSON(jsonValue));
    }

    /**
     * 1. Collect inputs - meta (dates, algo action), detail frames from the custom asset algo, and asset info 2. Run and return the position-level Lifecycle report.
     * Get Custom Asset Lifecycle
     */
    async getCustomAssetLifecycle(requestParameters: GetCustomAssetLifecycleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CustomAssetLifecycle> {
        const response = await this.getCustomAssetLifecycleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Optimization Metas
     */
    async getOptimizationMetaRaw(requestParameters: GetOptimizationMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OptimizationMeta>>> {
        const queryParameters: any = {};

        if (requestParameters.fromDate !== undefined) {
            queryParameters['from_date'] = requestParameters.fromDate;
        }

        if (requestParameters.toDate !== undefined) {
            queryParameters['to_date'] = requestParameters.toDate;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OptimizationMetaFromJSON));
    }

    /**
     * Get Optimization Metas
     */
    async getOptimizationMeta(requestParameters: GetOptimizationMetaRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OptimizationMeta>> {
        const response = await this.getOptimizationMetaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Optimization Result
     */
    async getOptimizationResultRaw(requestParameters: GetOptimizationResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OptimizationResult>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling getOptimizationResult.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/result`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OptimizationResultFromJSON(jsonValue));
    }

    /**
     * Get Optimization Result
     */
    async getOptimizationResult(requestParameters: GetOptimizationResultRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OptimizationResult> {
        const response = await this.getOptimizationResultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get Optimizer Details
     */
    async getOptimizerDetailsRaw(requestParameters: GetOptimizerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<OptimizerDetail>>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling getOptimizerDetails.');
        }

        if (requestParameters.pId === null || requestParameters.pId === undefined) {
            throw new runtime.RequiredError('pId','Required parameter requestParameters.pId was null or undefined when calling getOptimizerDetails.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/{optimization_id}/optimizer-details/p-id/{p_id}`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))).replace(`{${"p_id"}}`, encodeURIComponent(String(requestParameters.pId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(OptimizerDetailFromJSON));
    }

    /**
     * Get Optimizer Details
     */
    async getOptimizerDetails(requestParameters: GetOptimizerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<OptimizerDetail>> {
        const response = await this.getOptimizerDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Get a single Optimization Metadata
     */
    async getSingleOptimizationMetaRaw(requestParameters: GetSingleOptimizationMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OptimizationMeta>> {
        if (requestParameters.optimizationId === null || requestParameters.optimizationId === undefined) {
            throw new runtime.RequiredError('optimizationId','Required parameter requestParameters.optimizationId was null or undefined when calling getSingleOptimizationMeta.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/optimization/meta/{optimization_id}`.replace(`{${"optimization_id"}}`, encodeURIComponent(String(requestParameters.optimizationId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OptimizationMetaFromJSON(jsonValue));
    }

    /**
     * Get a single Optimization Metadata
     */
    async getSingleOptimizationMeta(requestParameters: GetSingleOptimizationMetaRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OptimizationMeta> {
        const response = await this.getSingleOptimizationMetaRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Run Allocation
     */
    async runAllocationRaw(requestParameters: RunAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AllocationRunOutput>> {
        if (requestParameters.accountGroupGuid === null || requestParameters.accountGroupGuid === undefined) {
            throw new runtime.RequiredError('accountGroupGuid','Required parameter requestParameters.accountGroupGuid was null or undefined when calling runAllocation.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/allocation/{account_group_guid}/run`.replace(`{${"account_group_guid"}}`, encodeURIComponent(String(requestParameters.accountGroupGuid))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AllocationRunOutputFromJSON(jsonValue));
    }

    /**
     * Run Allocation
     */
    async runAllocation(requestParameters: RunAllocationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AllocationRunOutput> {
        const response = await this.runAllocationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Submit New Optimization
     */
    async submitOptimizationRaw(requestParameters: SubmitOptimizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<OptimizationResponse>> {
        if (requestParameters.optimizationRequest === null || requestParameters.optimizationRequest === undefined) {
            throw new runtime.RequiredError('optimizationRequest','Required parameter requestParameters.optimizationRequest was null or undefined when calling submitOptimization.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("RoleBasedJWTAuthenticator", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/portfolio-optimizer/run`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: OptimizationRequestToJSON(requestParameters.optimizationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => OptimizationResponseFromJSON(jsonValue));
    }

    /**
     * Submit New Optimization
     */
    async submitOptimization(requestParameters: SubmitOptimizationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<OptimizationResponse> {
        const response = await this.submitOptimizationRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
